import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { FaExclamationCircle, FaCheckCircle, FaTasks, FaExclamationTriangle } from 'react-icons/fa'; // Example icons
import cx from 'classnames';
import { Link } from 'react-router-dom';
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Breadcrumb,
  BreadcrumbItem,
  Progress,
  Badge,
  Table
} from 'reactstrap';
import Widget from '../../components/Widget/Widget';
import LineChart from '../../components/charts/charts/LineChart';
import BarChart from '../../components/charts/charts/BarChart';
import PieChart from '../../components/charts/charts/PieChart';
import './Dashboard.css';
import { getComplianceDashboard, getComplianceForEachStandardDashboard, getUsersTasksDashboard } from '../../services/dashboards'; // Import the API call
import { getAllOrganization } from '../../services/userServicer'; // Import tenant service
import { useTranslation } from 'react-i18next';
import LoadingScreen from 'src/Loading/LoadingScreen';
import { RiProgress2Line } from 'react-icons/ri';
interface Post {
  id: number;
  title: string;
  updatedAt: string;
}

interface DashboardProps {
  posts: Post[];
  isFetching: boolean;
}





function DashboardSup() {
  const { t } = useTranslation();
  const [isDropdownOpened, setIsDropdownOpened] = useState(false);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [complianceStatus, setComplianceStatus] = useState<any>([]);
  const [monthlyTasks, setMonthlyTasks] = useState<any>([]);
  const [complianceForEachStandard, setComplianceForEachStandard] = useState<any>([]);
  const [usersTasksDashboard, setUsersTasksDashboard] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [tenants, setTenants] = useState<any[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<string>('');
  const [loadingTenants, setLoadingTenants] = useState(false);


  const fetchTenants = async () => {
    setLoadingTenants(true);
    try {
      const tenantsData = await getAllOrganization();
      //console.log('Tenants Data:', tenantsData);
      setTenants(tenantsData);
    } catch (error) {
      console.error("Error fetching tenants:", error);
    } finally {
      setLoadingTenants(false);
    }
  };

  const fetchDashboardData = async (tenantId?: string) => {
    setIsLoading(true);
    try {
      const data = await getComplianceDashboard(tenantId);
      //console.log(data,"dashboard data");
      
      if (data.success) {
        setDashboardData(data?.data);
        setComplianceStatus([{
          'Compliance': data?.data?.compliance,
          'Non_Compliance': data?.data?.non_compliance,
          'Partially': data?.data?.partially,
          'Not_Started': data?.data?.not_started,
          'In_Progress': data?.data?.in_progress,
          'Done': data?.data?.done,
          // 'Overdue': data?.data?.overdue
        }])
      
        const monthlyTasksWithMonthNames = data.data.monthlyTasks.map((task: any, index: number) => {
          const monthNames = [t("Jan"), t("Feb"), t("Mar"), t("Apr"), t("May"), t("Jun"), t("Jul"), t("Aug"), t("Sep"), t("Oct"), t("Nov"), t("Dec")];
          return { name: monthNames[index], noTasks: task };
        });
       
        setMonthlyTasks(monthlyTasksWithMonthNames);
        
      } else {
        setDashboardData(null);
      }
      
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchComplianceForEachStandardDashboard = async (tenantId?: string) => {
    try {
      const data = await getComplianceForEachStandardDashboard(tenantId);
      if (data.success) {
        const formattedData = data.data ? Object.keys(data.data).map((key: string) => ({
          id: key,
          reference_name: data.data[key].reference_name,
          fully_implemented: data.data[key].fully_implemented,
          mostly_implemented: data.data[key].mostly_implemented,
          averagely_implemented: data.data[key].averagely_implemented,
          implemented: data.data[key].implemented,
          partially_compliant: data.data[key].partially_compliant,
          non_compliant: data.data[key].non_compliant
        })) : [];
        
        setComplianceForEachStandard(formattedData);
      }
      
    } catch (error) {
      console.error("Error fetching compliance for each standard dashboard:", error);
    }
  }

  // const fetchUsersTasksDashboard = async (tenantId?: string) => {
  //   try {
  //     const data = await getUsersTasksDashboard(tenantId);
  //     if (data.success) {
  //       setUsersTasksDashboard(data.data);
  //     }
  //     console.log(data);
  //   } catch (error) {
  //     console.error("Error fetching users tasks dashboard:", error);
  //   }
  // }

  const handleTenantChange = (tenantId: string) => {
    setSelectedTenant(tenantId);
    const tenantParam = tenantId || undefined;
    fetchDashboardData(tenantParam);
    fetchComplianceForEachStandardDashboard(tenantParam);
    // fetchUsersTasksDashboard(tenantParam);
  };

  useEffect(() => {
    fetchTenants();
    fetchDashboardData();
    fetchComplianceForEachStandardDashboard();
    // fetchUsersTasksDashboard();
  }, []);

  const formatDate = (str: string) => {
    return str.replace(/,.*$/, "");
  };

  // const toggleDropdown = () => {
  //   setIsDropdownOpened(!isDropdownOpened);
  // };

  if (isLoading) {
    return (
      <div className="loading-screen" 
      style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>
                     <div><LoadingScreen/></div>
                   </div>
    );
  }


  return (
    <div className="root dashboard">
     
        <>
          
        <div className="dashboard-container p-3">
  {/* Header Section with Organization Selector */}
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 p-3 bg-white rounded shadow-sm">
    <h4 className="mb-3 mb-md-0 ">{t('Dashboard.Dashboard')}</h4>
    <div className="w-50">
      <label className="form-label fw-medium text-muted d-block mb-2">
        {t('Dashboard.Select_Organization')}
      </label>
      <select
        className="form-select w-100 border-gray-300 shadow-none"
        value={selectedTenant}
        onChange={(e) => handleTenantChange(e.target.value)}
        disabled={loadingTenants}
      >
        <option value="">
          {loadingTenants 
            ? t('Dashboard.Loading_Organizations') 
            : t('Dashboard.All_Organizations')}
        </option>
        {Array.isArray(tenants) && tenants.map((tenant) => (
          <option key={tenant.id} value={tenant.id}>
            {tenant.name}
          </option>
        ))}
      </select>
    </div>
  </div>

  {/* Stats Cards */}
  {/* <Row className='g-3 mb-4'>
    <Col sm={12} md={6} lg={3}>
      <div className='card h-100 border-0 shadow-sm'>
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <h6 className="fw-semibold text-muted mb-2">{t('Dashboard.Remaining_Tasks')}</h6>
            <h2 className=" mb-0">{dashboardData?.in_progress + dashboardData?.not_started}</h2>
          </div>
          <div className='bg-primary p-3 rounded-circle'>
            <FaExclamationCircle size={24} className="text-white" />
          </div>
        </div>
      </div>
    </Col>

    <Col sm={12} md={6} lg={3}>
      <div className='card h-100 border-0 shadow-sm'>
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <h6 className="fw-semibold text-muted mb-2">{t('Dashboard.Completed_Tasks')}</h6>
            <h2 className="text-success mb-0">{dashboardData?.done}</h2>
          </div>
          <div className='bg-success p-3 rounded-circle'>
            <FaCheckCircle size={24} className="text-white" />
          </div>
        </div>
      </div>
    </Col>

    <Col sm={12} md={6} lg={3}>
      <div className='card h-100 border-0 shadow-sm'>
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <h6 className="fw-semibold text-muted mb-2">{t('Dashboard.Tasks_in_progress')}</h6>
            <h2 className="text-warning mb-0">{dashboardData?.in_progress}</h2>
          </div>
          <div className='bg-warning p-3 rounded-circle'>
            <RiProgress2Line size={24} className="text-white" />
          </div>
        </div>
      </div>
    </Col> */}

    {/* Uncomment if needed
    <Col sm={12} md={6} lg={3}>
      <div className='card h-100 border-0 shadow-sm'>
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <h6 className="fw-semibold text-muted mb-2">{t('Dashboard.Overdue_tasks')}</h6>
            <h2 className="text-danger mb-0">{dashboardData?.overdue}</h2>
          </div>
          <div className='bg-danger p-3 rounded-circle'>
            <FaExclamationTriangle size={24} className="text-white" />
          </div>
        </div>
      </div>
    </Col>
    */}
  {/* Stats Cards Section */}
    <Row className='g-3 mb-4'>
            <Col sm={12} md={4}>
              <div 
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                  padding: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  height: "100%"
                }}
              >
                {/* Icon Container */}
                <div
                  style={{
                    backgroundColor: "#ffc107",
                    width: "56px",
                    height: "56px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0
                  }}
                >
                  <FaExclamationTriangle size={24} style={{ color: "white" }} />
                </div>
                
                {/* Metric Information */}
                <div style={{ flex: 1, textAlign: "right", direction: "rtl" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                    <h6 
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#6c757d",
                        margin: 0
                      }}
                    >
                      {t("Dashboard.Total Tenants")}
                    </h6>
                    <h2 
                      style={{
                        fontSize: "28px",
                        fontWeight: 700,
                        color: "#212529",
                        margin: 0,
                        lineHeight: 1
                      }}
                    >
                      {dashboardData?.totalTenants || 0}
                    </h2>
                  </div>
                </div>
              </div>
            </Col>

            <Col sm={12} md={4}>
              <div 
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                  padding: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  height: "100%"
                }}
              >
                {/* Icon Container */}
                <div
                  style={{
                    backgroundColor: "#28a745",
                    width: "56px",
                    height: "56px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0
                  }}
                >
                  <FaCheckCircle size={24} style={{ color: "white" }} />
                </div>
                
                {/* Metric Information */}
                <div style={{ flex: 1, textAlign: "right", direction: "rtl" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                    <h6 
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#6c757d",
                        margin: 0
                      }}
                    >
                      {t("Dashboard.Compliant Tenants")}
                    </h6>
                    <h2 
                      style={{
                        fontSize: "28px",
                        fontWeight: 700,
                        color: "#212529",
                        margin: 0,
                        lineHeight: 1
                      }}
                    >
                      {dashboardData?.compliance || 0}
                    </h2>
                  </div>
                </div>
              </div>
            </Col>

            <Col sm={12} md={4}>
              <div 
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                  padding: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  height: "100%"
                }}
              >
                {/* Icon Container */}
                <div
                  style={{
                    backgroundColor: "#007bff",
                    width: "56px",
                    height: "56px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0
                  }}
                >
                  <FaExclamationCircle size={24} style={{ color: "white" }} />
                </div>
                
                {/* Metric Information */}
                <div style={{ flex: 1, textAlign: "right", direction: "rtl" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                    <h6 
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#6c757d",
                        margin: 0
                      }}
                    >
                      {t("Dashboard.Non Compliant Tenants")}
                    </h6>
                    <h2 
                      style={{
                        fontSize: "28px",
                        fontWeight: 700,
                        color: "#212529",
                        margin: 0,
                        lineHeight: 1
                      }}
                    >
                      {dashboardData?.non_compliance || 0}
                    </h2>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
  {/* Charts Section */}
  <Row className='g-3 mb-4'>
    <Col xs={12} lg={4}>
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body">
          <h5 className="card-title fw-semibold ">
            {t('Dashboard.Reference/Compliance')}
          </h5>
          <hr className="my-3" />
          <div className="chart-container" style={{ height: '300px' }}>
            <BarChart data={complianceForEachStandard} />
          </div>
        </div>
      </div>
    </Col>

    <Col xs={12} lg={4}>
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body">
          <h5 className="card-title fw-semibold ">
            {t('Dashboard.Simple_Tasks')}
          </h5>
          <hr className="my-3" />
          <div className="chart-container" style={{ height: '300px' }}>
            <LineChart data={monthlyTasks} />
          </div>
        </div>
      </div>
    </Col>

    <Col xs={12} lg={4}>
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body">
          <h5 className="card-title fw-semibold ">
            {t('Dashboard.Compliance_Status')}
          </h5>
          <hr className="my-3" />
          <div className="chart-container" style={{ height: '300px' }}>
            <PieChart data={complianceStatus} />
          </div>
        </div>
      </div>
    </Col>
  </Row>

  {/* Users tasks table section is intentionally commented out to simplify the header. */}
</div>
     
           

        </>
      
    </div>
  );
}

export default withTranslation()(DashboardSup);
